import { Flex, Typography, Calendar, Spin } from "antd";
import React, { useEffect, useState } from "react";
import Logo from "../../Components/SVGs/Logo";
import Home from "../../Components/SVGs/Home";
import Profile from "../../Components/SVGs/Profile";
import CalendarIcon from "../../Components/SVGs/Calendar";
import Plates from "../../Components/SVGs/Plates";
import InfoRestaurantHome from "../../Components/InfoRestaurantHome/InfoRestaurantHome";
import { ChartHome } from "../../Components/ChartHome/ChartHome";
import WarnHome from "../../Components/WarnsHome/WarnHome";
import Menu from "../../Components/Menu/Menu";
import { Link, useNavigate } from "react-router-dom";
import HomeActiveIcon from "../../Components/SVGs/HomeActiveIcon";
import ProfileInfo from "../../Components/ProfileInfo/ProfileInfo";
import Days from "../../Components/Days/Days";
import RestaurantInfoName from "../../Components/RestaurantInfo/RestaurantInfoName";
import {
  MenuOfTheDayService,
  MenuService,
  RestaurantService,
} from "deliziora-client-module/client-web";

import { isMobile } from "react-device-detect";
import MenuCalendar from "../../Components/Menu/MenuCalendar";
import { ChartHomeRestaurantVisitors } from "../../Components/ChartHomeRestaurantVisitors/ChartHomeRestaurantVisitors";
export default function NewDashboardPage() {
  var today = new Date();
  var dayOfWeek = today.getDay();
  var daysOfWeek = [
    "domingo",
    "segunda",
    "terça",
    "quarta",
    "quinta",
    "sexta",
    "sábado",
  ];
  var dayName = daysOfWeek[dayOfWeek];
  const [currentDate, setCurrentDate] = useState(dayName);
  const [name, setName] = useState({ restaurant: null });
  const [plates, setPlates] = useState([]);
  const [selectedDay, setSelectedDay] = useState("");
  const [Day, setDay] = useState(0);
  const [menuItems, setMenuItems] = useState([]);
  const userData = JSON.parse(localStorage.getItem("userData"));
  const navigate = useNavigate();
  useEffect(() => {
    MenuService.returnAllMenu()
      .then((res) => {
        const filteredDataByRestaurantId = res.data.filter(
          (item) => item.id_Restaurants === userData._id.$oid
        );
        setPlates(filteredDataByRestaurantId);
      })
      .catch((err) => {
        console.error("ERROR ", err);
      });
  }, []);
  useEffect(() => {
    console.log(Day);
    const fetchData = async () => {
      try {
        const resMenuDay =
          await MenuOfTheDayService.returnAllMenuOfDayByRestaurant(
            userData._id.$oid
          );
        const res = await MenuService.returnAllMenu();

        const matchingMenuItems = [];

        if (plates && resMenuDay.data) {
          resMenuDay.data.forEach((itemDay) => {
            const matchingItemsForDay = res.data.filter(
              (item) => itemDay.id_menu === item._id.$oid && itemDay.day === Day
            );

            matchingItemsForDay.forEach((matchingItem) => {
              const isDuplicate = matchingMenuItems.some(
                (existingItem) =>
                  existingItem._id.$oid === matchingItem._id.$oid
              );

              if (!isDuplicate) {
                matchingMenuItems.push(matchingItem);
              }
            });
          });
          setMenuItems(matchingMenuItems);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [selectedDay, Day]);

  const dayMap = {
    segunda: 1,
    terça: 2,
    quarta: 3,
    quinta: 4,
    sexta: 5,
    sábado: 6,
    domingo: 7,
  };

  useEffect(() => {
    const numericDay = dayMap[currentDate];
    if (numericDay) {
      setDay(numericDay);
    }
  }, [currentDate]);

  return (
    <Flex
      vertical
      align="center"
      justify="center"
      style={{
        alignSelf: "center",
        marginTop: "1rem",
        justifySelf: "center",
      }}
    >
      <Typography.Title level={2}>Dashboard</Typography.Title>
      {isMobile ? (
        <Flex vertical>
          <Flex
            style={{
              width: "90%",
              minWidth: "90%",
              maxWidth: "90%",
              height: "100%",
              alignSelf: "center",
              justifySelf: "center",
              gap: "1rem",
              boxShadow: "0 0 5px 0 rgba(0, 0, 0, 0.077)",
              borderRadius: "5px",
              marginBottom: "1rem",
            }}
          >
            <InfoRestaurantHome />
          </Flex>
          <Flex
            style={{
              width: "90%",
              minWidth: "90%",
              maxWidth: "90%",
              height: "100%",
              alignSelf: "center",
              justifySelf: "center",
              gap: "1rem",
              boxShadow: "0 0 5px 0 rgba(0, 0, 0, 0.077)",
              borderRadius: "5px",
              marginBottom: "1rem",
            }}
          >
            <ChartHomeRestaurantVisitors />
          </Flex>
          <Flex
            style={{
              width: "90%",
              minWidth: "90%",
              maxWidth: "90%",
              height: "100%",
              alignSelf: "center",
              justifySelf: "center",
              gap: "1rem",
              boxShadow: "0 0 5px 0 rgba(0, 0, 0, 0.077)",
              borderRadius: "5px",
              marginBottom: "1rem",
            }}
          >
            <Days setSelectedDay={setSelectedDay} setDay={setDay} />
          </Flex>
          <Flex
            style={{
              width: "90%",
              minWidth: "90%",
              maxWidth: "90%",
              height: "100%",
              alignSelf: "center",
              justifySelf: "center",
              gap: "1rem",
              boxShadow: "0 0 5px 0 rgba(0, 0, 0, 0.077)",
              borderRadius: "5px",
              marginBottom: "1rem",
            }}
          >
            <MenuCalendar selectedDay={selectedDay} Day={Day} />
          </Flex>
        </Flex>
      ) : (
        <Flex
          style={{
            width: "90%",
            minWidth: "90%",
            maxWidth: "90%",
            height: "100%",
            minHeight: "100vh",
            alignSelf: "center",
            justifySelf: "center",
            gap: "1rem",
            boxShadow: "0 0 5px 0 rgba(0, 0, 0, 0.077)",
            borderRadius: "5px",
          }}
        >
          <Flex
            vertical
            align="center"
            justify="center"
            style={{
              width: "50%",
              gap: "1rem",
              boxShadow: "0 0 5px 0 rgba(0, 0, 0, 0.077)",
              borderRadius: "5px",
              height: "100%",
            }}
          >
            <Flex
              style={{
                boxShadow: "0 0 5px 0 rgba(0, 0, 0, 0.077)",
                borderRadius: "5px",
                width: "100%",
                height: "100%",
              }}
            >
              <InfoRestaurantHome />
            </Flex>
            <Flex
              style={{
                boxShadow: "0 0 5px 0 rgba(0, 0, 0, 0.077)",
                borderRadius: "5px",
                width: "100%",
                height: "35%",
              }}
            >
              <ChartHomeRestaurantVisitors />
            </Flex>
            <Flex
              style={{
                boxShadow: "0 0 5px 0 rgba(0, 0, 0, 0.077)",
                borderRadius: "5px",
                width: "100%",
                height: "30%",
                maxHeight: "30%",
              }}
            >
              <Days setSelectedDay={setSelectedDay} setDay={setDay} />
            </Flex>
          </Flex>
          <Flex
            style={{
              width: "50%",
              boxShadow: "0 0 5px 0 rgba(0, 0, 0, 0.077)",
              borderRadius: "5px",
              height: "100%",
              minHeight: "100vh",
              padding: "1rem",
              gap: "2rem",
              backgroundColor: "white",
            }}
          >
            <MenuCalendar selectedDay={selectedDay} Day={Day} />
          </Flex>
        </Flex>
      )}
    </Flex>
  );
}
